import { apiRequest } from "../apiRequest";
import { unstoreContact } from "./unstoreContact";

export async function deleteContact(id: string) {
  await apiRequest({ url: `contacts/${id}`, method: "DELETE" });
  unstoreContact(id);
}
